import Intro from "./components/intro"
import Charter from "./components/charter"
import Event from "./components/event"
import Statistics from "./components/statistics"

const WhoWeAre = () => {
	return <div>
		<Intro />
		<Charter />
		{/* <Event /> */}
		<Statistics />
	</div>
}
export default WhoWeAre